export const REAL_ESTATE_TAXES_SALT_CAP = 40000;
